import React, { useState, useEffect } from 'react';
import { ParticleSystem } from './components/ParticleSystem';
import { WebGLShader } from './components/WebGLShader';
import { CSSAnimation } from './components/CSSAnimation';
import { PixelSimulation } from './components/PixelSimulation';
import { SVGAnimation } from './components/SVGAnimation';
import { FractalFlame } from './components/FractalFlame';

const App = () => {
  const [currentPage, setCurrentPage] = useState(0);
  
  const simulations = [
    { component: ParticleSystem, name: "Particle System" },
    { component: WebGLShader, name: "WebGL Shader" },
    { component: CSSAnimation, name: "CSS Animation" },
    { component: PixelSimulation, name: "Pixel Simulation" },
    { component: SVGAnimation, name: "SVG Animation" },
    { component: FractalFlame, name: "Fractal Flame" }
  ];

  const CurrentSimulation = simulations[currentPage].component;

  const nextPage = () => {
    setCurrentPage((prev) => (prev + 1) % simulations.length);
  };

  const prevPage = () => {
    setCurrentPage((prev) => (prev - 1 + simulations.length) % simulations.length);
  };

  // Add keyboard navigation
  useEffect(() => {
    const handleKeyPress = (event) => {
      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          prevPage();
          break;
        case 'ArrowRight':
          event.preventDefault();
          nextPage();
          break;
        default:
          break;
      }
    };

    // Add event listener
    window.addEventListener('keydown', handleKeyPress);
    
    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header className="header">
        <h1>Candle Flame Simulations</h1>
        <div className="nav-dots">
          {simulations.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentPage(index)}
              className={`nav-dot ${index === currentPage ? 'active' : ''}`}
            />
          ))}
        </div>
      </header>
      
      <main className="main-container">
        <div className="content-area">
          <CurrentSimulation />
        </div>
        
        <button
          onClick={prevPage}
          className="nav-button prev"
        >
          ←
        </button>
        
        <button
          onClick={nextPage}
          className="nav-button next"
        >
          →
        </button>
      </main>
      
      <footer className="footer">
        {currentPage + 1} / {simulations.length} - {simulations[currentPage].name}
      </footer>
    </div>
  );
};

export default App;
